import React from "react";

import Style from "./widget.module.scss";

const Widget = ({
    title,
    children,
    id
}: {
    title: string;
    children?: React.ReactNode;
    id?: string;
}) => {
    return (
        <div className={Style.widget} id={id}>
            <div className={Style.head}>{title}</div>
            {children && <div>{children}</div>}
        </div>
    );
};

export default Widget;
